import { render, staticRenderFns } from "./ImgBed.vue?vue&type=template&id=701be7e8&scoped=true"
import script from "./ImgBed.vue?vue&type=script&lang=js"
export * from "./ImgBed.vue?vue&type=script&lang=js"
import style0 from "./ImgBed.vue?vue&type=style&index=0&id=701be7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701be7e8",
  null
  
)

export default component.exports